import React from "react";
import { Link } from "react-router-dom";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowUp,
  FaStethoscope,
  FaClock,
} from "react-icons/fa";
import { CLINIC_GOOGLE_MAPS_LINK } from "../utils/addressUtils";
import {
  HELPDESK_PHONE_DISPLAY,
  EMERGENCY_PHONE_DISPLAY,
  HELPDESK_PHONE_TEL,
  EMERGENCY_PHONE_TEL,
} from "../utils/clinicContact";
import "./Footer.css";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const currentYear = new Date().getFullYear();

  // Services data matching the Services page
  const services = [
    "Angiography",
    "Angioplasty",
    "Stent Placement",
    "Valvuloplasty",
    "TAVR",
    "Mitral Valve Repair/Replacement",
    "Fractional Flow Reserve (FFR)",
    "Chronic Total Occlusion (CTO)",
    "Atherectomy",
    "Pericardiocentesis",
    "Cardiac Catheterization",
    "Endovenous Thermal Ablation",
    "ECG",
    "Heart Checkup",
    "Stress Test",
    "Echocardiography",
    "Preventive Cardiology",
    "Cardiac Consultation",
    "Percutaneous Device Closures",
    "Pacemaker Implantation",
    "Cardiac Resynchronising Therapy (CRT)",
    "AICD Implantation",
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Clinic Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <div className="footer-logo-text">
                <h3>
                  <FaStethoscope className="doctor-icon" />
                  Dr. Satya Sudhish Nimmagadda
                </h3>
                <span>SATYA HEART CLINIC</span>
              </div>
            </div>
            <p className="footer-description">
              Providing exceptional cardiac care with compassion and expertise.
              Your heart health is our priority.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/patient-info">Patient Info</Link>
              </li>
              <li>
                <Link to="/testimonials">Testimonials</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul className="footer-links">
              {services.slice(0, 8).map((service, index) => (
                <li key={index}>
                  <Link to="/services">{service}</Link>
                </li>
              ))}
              {services.length > 8 && (
                <li>
                  <Link to="/services">View All Services →</Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Information</h4>
            <div className="footer-contact">
              <div>
                <FaMapMarkerAlt className="contact-icon" />
                <p>
                  <a
                    href={CLINIC_GOOGLE_MAPS_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="address-link"
                    title="Click to open in Google Maps"
                  >
                    Shop No-6, Shopping Complex, Vasanth Nagar, IDPL Staff
                    Cooperative Housing Society, Vasanth Nagar, Kukatpally,
                    Hyderabad, Telangana 500085
                  </a>
                </p>
              </div>
              <div>
                <FaPhone className="contact-icon" />
                <div>
                  <a href={`tel:${HELPDESK_PHONE_TEL}`}>
                    Helpdesk: {HELPDESK_PHONE_DISPLAY}
                  </a>
                  <p>
                    <a href={`tel:${EMERGENCY_PHONE_TEL}`}>
                      Emergency: {EMERGENCY_PHONE_DISPLAY}
                    </a>
                  </p>
                </div>
              </div>
              <div>
                <FaEnvelope className="contact-icon" />
                <a href="mailto:satya.s.nimmagadda@gmail.com">
                  satya.s.nimmagadda@gmail.com
                </a>
              </div>
              <div>
                <FaClock className="contact-icon" />
                <div>
                  <p>Monday to Saturday, 6:00 PM - 9:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} SATYA HEART CLINIC. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        className="scroll-to-top"
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <FaArrowUp />
      </button>
    </footer>
  );
};

export default Footer;
